import { createContext, type ReactNode, useContext, useState } from 'react';
import { guiCoverGeniusTheme, guiRentalCoverTheme } from './guiThemes.css';

const themes: Record<string, string> = {
  coverGenius: guiCoverGeniusTheme,
  rentalCover: guiRentalCoverTheme,
};

interface IThemeContext {
  theme: string;
  setTheme: (theme: string) => void;
  availableThemes: string[];
}

const ThemeContext = createContext<IThemeContext | null>(null);

export function useTheme(): IThemeContext {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
}

interface IThemeProvider {
  defaultTheme?: string;
  children: ReactNode;
}

export function ThemeProvider({
  defaultTheme = 'coverGenius',
  children,
}: IThemeProvider) {
  const [theme, setTheme] = useState(defaultTheme);
  const availableThemes = Object.keys(themes);

  const className = themes[theme] ?? '';

  return (
    <ThemeContext.Provider value={{ theme, setTheme, availableThemes }}>
      <div className={className}>{children}</div>
    </ThemeContext.Provider>
  );
}
